import { DateTime, Duration } from 'luxon';
import { CommittedOrder } from 'planning-portal-library/src/lib/core/domain';

import { Mapper } from '../../../../../core/base';
import { CommittedOrderWebEntity } from './committed-order-web-entity';

export class CommittedOrderWebRepositoryMapper extends Mapper<
  CommittedOrderWebEntity,
  CommittedOrder
> {
  mapFrom(param: CommittedOrderWebEntity): CommittedOrder {
    return {
      id: param.id,
      name: param.name,
      masterPlanName: param.masterPlanName,
      description: param.description,
      distance: param.distance ? param.distance : undefined,
      duration: param.duration
        ? Duration.fromMillis(param.duration)
        : undefined,
      jobsCount: param.jobsCount,
      locationsCount: param.locationsCount,
      planTypeId: param.planTypeId,
      distributionLaneId: param.distributionLaneId,
      distributionLaneName: param.distributionLaneName,
      planTypeName: param.planTypeName,
      units: param.units,
      planContainerId: param.planContainerId,
      status: param.status,
      hasJobFilters: param.hasJobFilters,
      isPlanRevised: param.isPlanRevised,
      isScheduled: param.isScheduled,
      createdAt: DateTime.fromISO(param.createdAt ?? ''),
      day: param.day,
    };
  }

  mapTo(param: CommittedOrder): CommittedOrderWebEntity {
    return {
      id: param.id,
      name: param.name,
      masterPlanName: param.masterPlanName,
      description: param.description,
      distance: param.distance,
      duration: param.duration?.toMillis(),
      jobsCount: param.jobsCount,
      locationsCount: param.locationsCount,
      planTypeId: param.planTypeId,
      distributionLaneId: param.distributionLaneId,
      distributionLaneName: param.distributionLaneName,
      planTypeName: param.planTypeName,
      units: param.units,
      planContainerId: param.planContainerId,
      status: param.status,
      isScheduled: param.isScheduled,
      hasJobFilters: param.hasJobFilters,
      isPlanRevised: param.isPlanRevised,
      createdAt: param.createdAt?.toISO(),
      day: param.day,
    };
  }
}
